/* eslint-disable @angular-eslint/component-selector */
import { OnInit, Component, Input, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';

import { toggleTabIndex } from '@backbase/internal-payments-shared-ui';

import { ErrorMessage } from '../../utils/models/shared.model';

@Component({
  selector: 'sbk-payord-validation-message',
  templateUrl: './sbk-payord-validation-message.component.html',
})
export class SbkPayordValidationMessageComponent implements OnInit {
  /**
   * The form control instance
   */
  @Input() control!: FormControl;
  /**
   * List of validation messages
   */
  @Input() validationMessages!: Array<ErrorMessage>;
  /**
   * Label of the form control
   */
  @Input() label!: string;
  /**
   * Id of validation message
   */
  @Input() id!: string;

  /**
   * If Generic messages are not needed.
   */
  @Input() hideGeneric = false;

  requiredMessage!: string;
  validationMessage!: string;

  constructor(private readonly elRef: ElementRef) { }

  ngOnInit() {
    this.validationMessages = this.validationMessages || [];
  }

  getValidationMessage(error?: string): string {
    this.validationMessage = '';
    if (this.control?.errors && this.validationMessages.length) {
      for (const msg of this.validationMessages) {
        if (error && msg.name === error) {
          this.validationMessage = msg.message;
          return this.validationMessage;
        } else if (this.control?.errors[msg.name]) {
          this.validationMessage = msg.message;
          return this.validationMessage;
        }
      }
    }
    return this.validationMessage;
  }

  getRequiredMessage(): string {
    this.requiredMessage = this.getValidationMessage('required');
    return this.requiredMessage;
  }

  onFocusout() {
    toggleTabIndex('.bb-input-validation-message', this.elRef.nativeElement, false);
  }
}
